/*
  led-qty-limit.js

  Two jobs:

  1. PREVENT the over-quantity error. The quantity input now carries a `max`
     equal to the variant's available stock (set in led-wattz-product.liquid).
     This clamps typed values, disables the "+" button at the ceiling, and
     explains the adjustment instead of letting the customer submit a
     quantity Shopify will reject.

  2. RECOVER when it happens anyway (stock sold between page load and submit,
     or another tab). Dawn's product-form.js returns early on an error
     response and never re-renders the cart, so a partial add leaves the
     header bubble stale at the old total. We listen for the cartError event
     and refresh the bubble regardless.
*/
(function () {
  'use strict';

  if (window.__ledQtyLimitBound) return;
  window.__ledQtyLimitBound = true;

  var SELECTOR = '[data-lwp-qty] input[type="number"]';

  function wrapperFor(input) {
    return input ? input.closest('[data-lwp-qty]') : null;
  }

  function panelFor(input) {
    var wrap = wrapperFor(input);
    return wrap ? wrap.closest('.lwp-qty-panel') : null;
  }

  function maxFor(input) {
    var max = parseInt(input.getAttribute('max') || '', 10);
    return isNaN(max) ? null : max;
  }

  function showLimitMessage(input, text) {
    var panel = panelFor(input);
    var el = panel && panel.querySelector('[data-lwp-qty-limit]');
    if (!el) return;

    if (!text) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    el.textContent = text;
    el.hidden = false;

    clearTimeout(el.__hideTimer);
    el.__hideTimer = setTimeout(function () {
      el.hidden = true;
    }, 6000);
  }

  function syncPlusButton(input) {
    var wrap = wrapperFor(input);
    if (!wrap) return;

    var plus = wrap.querySelector('[data-lwp-qty-plus]');
    var max = maxFor(input);
    if (!plus || max === null) return;

    var atMax = parseInt(input.value || '0', 10) >= max;
    plus.disabled = atMax;
    plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
  }

  /* Clamp to [min, max]. `announce` is false while the user is mid-typing so
     we don't fight them on every keystroke. */
  function clamp(input, announce) {
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = maxFor(input);
    var raw = input.value;
    var val = parseInt(raw || '', 10);

    if (raw === '') {
      syncPlusButton(input);
      return;
    }

    if (isNaN(val) || val < min) val = min;

    if (max !== null && val > max) {
      val = max;
      if (announce) {
        var wrap = wrapperFor(input);
        showLimitMessage(input, (wrap && wrap.dataset.lwpLimitText) || 'Quantity adjusted to available stock.');
      }
    }

    if (String(val) !== String(raw)) {
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncPlusButton(input);
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest(SELECTOR);
    if (input) clamp(input, false);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest(SELECTOR);
    if (input) clamp(input, true);
  });

  document.addEventListener('blur', function (e) {
    var input = e.target.closest && e.target.closest(SELECTOR);
    if (input) clamp(input, true);
  }, true);

  /* The +/- handlers in led-wattz-product.js already honour `max`; this just
     keeps the button's disabled state correct after they run. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lwp-qty-plus], [data-lwp-qty-minus]');
    if (!btn) return;

    var wrap = btn.closest('[data-lwp-qty]');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;

    setTimeout(function () {
      var max = maxFor(input);
      if (max !== null && parseInt(input.value || '0', 10) >= max && btn.hasAttribute('data-lwp-qty-plus')) {
        showLimitMessage(input, (wrap.dataset.lwpLimitText || 'Quantity adjusted to available stock.'));
      }
      syncPlusButton(input);
    }, 0);
  });

  /* ---- Cart UI recovery ---- */

  function refreshCartBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('#cart-icon-bubble');
        var current = document.querySelector('#cart-icon-bubble');
        if (next && current) current.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  function onCartError() {
    /* Shopify may have added a reduced quantity before erroring, so the
       header total can be out of date either way. Refresh unconditionally. */
    refreshCartBubble();

    /* Re-read live stock and tighten the input so the next attempt succeeds. */
    var input = document.querySelector(SELECTOR);
    if (!input) return;

    var form = input.form || document.querySelector('form[data-type="add-to-cart-form"]');
    var idField = form && form.querySelector('[name="id"]');
    if (!idField) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var inCart = 0;
        cart.items.forEach(function (item) {
          if (String(item.variant_id) === String(idField.value)) inCart += item.quantity;
        });

        if (inCart > 0) {
          var max = maxFor(input);
          var remaining = max === null ? null : Math.max(0, max - inCart);
          if (remaining !== null) {
            input.setAttribute('max', remaining);
            clamp(input, true);
          }
        }
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
    subscribe(PUB_SUB_EVENTS.cartError, onCartError);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(SELECTOR).forEach(function (input) {
      syncPlusButton(input);
    });
  });
})();
